export const updateItem = (data) => {
    return {
        type: 'TOKEN_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};
export const setSearchValue = (value) => {
    return {
        type: 'TOKEN_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};
export const setSelectedItem = (data) => {
    return {
        type: 'TOKEN_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const setItems = (items) => {
    return {
        type: 'TOKEN_SET_ITEMS',
        payload: {
            items,
        },
    };
};
export const addItem = (data) => {
    return {
        type: 'TOKEN_ADD_ITEM',
        payload: {
            data,
        },
    };
};
export const setTransportGroups = (groups, tokenId) => {
    return {
        type: 'TOKEN_SET_TRANSPORT_GROUPS',
        payload: {
            groups,
            tokenId,
        },
    };
};
export const toggleTransportGroup = (id) => {
    return {
        type: 'TOKEN_TOGGLE_TRANSPORT_GROUP',
        payload: {
            id,
        },
    };
};
